
import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import LocationManagement from '@/components/LocationManagement';
import { useLanguage } from '@/contexts/LanguageContext';

const LocationPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-white border-b border-gray-200 px-4 py-4">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-6 w-6" />
          </Button>
          <h1 className="text-xl font-semibold">{t('your_locations')}</h1>
        </div>
      </div>
      
      <div className="px-4 py-6">
        <LocationManagement />
      </div>
    </div>
  );
};

export default LocationPage;
